module.exports = __webpack_public_path__ + "static/integration-20d1539102a0f5263a095bfae3e2960f.webp";